import { c as _c } from "react/compiler-runtime";
import { ArchiveIcon, MapLargeIcon, WarningIcon, ProcoreIcon, AutodeskIcon } from "@flat-ui";
import { PALETTE_VARS } from "@styles/palette-vars";

/** Archive icon from design system with independent arrow and border colors */
export function ArchiveTwoToneIcon(props) {
  const $ = _c(7);
  let t0;
  if ($[0] !== props.sx) {
    t0 = Array.isArray(props.sx) ? props.sx : [props.sx];
    $[0] = props.sx;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = [...t0, _temp];
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== props || $[5] !== t1) {
    t2 = <ArchiveIcon {...props} sx={t1} />;
    $[4] = props;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}

/** Map list icon from design system with independent arrow and border colors */
function _temp(theme) {
  return {
    "& > g > path:first-of-type": {
      fill: PALETTE_VARS.primary.light
    },
    "& > g > path:last-of-type": {
      fill: theme.vars.palette.text.secondary
    }
  };
}
export function MapListTwoToneIcon(props) {
  const $ = _c(7);
  let t0;
  if ($[0] !== props.sx) {
    t0 = Array.isArray(props.sx) ? props.sx : [props.sx];
    $[0] = props.sx;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = [...t0, _temp2];
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== props || $[5] !== t1) {
    t2 = <MapLargeIcon {...props} sx={t1} />;
    $[4] = props;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}

/** Warning icon from design system with independent arrow and border colors */
function _temp2(theme) {
  return {
    "& > g > path:nth-of-type(2)": {
      fill: theme.vars.palette.text.secondary
    },
    "& > g > circle": {
      fill: PALETTE_VARS.primary.light
    },
    "& > g > circle:first-of-type": {
      fill: theme.vars.palette.text.secondary
    }
  };
}
export function WarningTwoToneIcon(props) {
  const $ = _c(7);
  let t0;
  if ($[0] !== props.sx) {
    t0 = Array.isArray(props.sx) ? props.sx : [props.sx];
    $[0] = props.sx;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = [...t0, _temp3];
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== props || $[5] !== t1) {
    t2 = <WarningIcon {...props} sx={t1} />;
    $[4] = props;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}

/** Procore icon with white logo area forced to black for light backgrounds. */
function _temp3(theme) {
  return {
    "& > g": {
      fill: PALETTE_VARS.primary.light
    },
    "& > path:first-of-type": {
      fill: theme.vars.palette.text.secondary
    },
    "& > path:last-of-type": {
      fill: "none"
    }
  };
}
export function ProcoreIntegrationIcon(props) {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      fill: PALETTE_VARS.text.primary
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props.sx) {
    t1 = {
      ...props.sx,
      "& path:first-of-type": t0
    };
    $[1] = props.sx;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props || $[4] !== t1) {
    t2 = <ProcoreIcon {...props} sx={t1} />;
    $[3] = props;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}

/** Autodesk icon with white logo area forced to black for light backgrounds. */
export function AutodeskIntegrationIcon(props) {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      fill: PALETTE_VARS.text.primary
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props.sx) {
    t1 = {
      ...props.sx,
      "& path:first-of-type": t0
    };
    $[1] = props.sx;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props || $[4] !== t1) {
    t2 = <AutodeskIcon {...props} sx={t1} />;
    $[3] = props;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}